<template>
    <confirmation-dialog
        ref="dialog"
        label="Assistent verwijderen"
        description="Weet je zeker dat je deze assistent wilt verwijderen?"
    >
        <template #default>
            <text-heading>Weet u dit zeker?</text-heading>
            <p>
                Weet u zeker dat u deze assistent wil verwijderen?
                <br>Dit kan niet meer ongedaan worden!
            </p>
        </template>
        <template #actions="{ bindings }">
            <button-outline @click="bindings.overlay.closeOverlay();">
                Annuleren
            </button-outline>
            <button-block
                @loading="(event) => {
                    event.button.setState(ButtonState.content);
                    bindings.overlay.closeOverlay();
                    emit('confirm');
                }"
            >
                Bevestig
            </button-block>
        </template>
    </confirmation-dialog>
</template>

<script setup lang="ts">
    import { ButtonState, ConfirmationDialog, type ExposedOverlay } from '@keyvue/one-ui';
    import { ref } from 'vue';

    const dialog = ref<ExposedOverlay>();
    const emit = defineEmits<{
        (e: 'confirm'): void;
    }>();

    defineExpose({
        dialog,
    });
</script>
